import React from "react";
import ConfigureSide from "./ConfigureSidebar/ConfigureSidebar";
import { Outlet } from "react-router-dom";

export default function Configure() {
	return (
		<>
			<div className="grid grid-cols-5">
				<div className="col-span-1">
					<ConfigureSide />
				</div>
				<div className="col-span-4 max-h-screen overflow-auto">
					<Outlet />
				</div>
			</div>
		</>
	);
}
